import { inject, Injectable } from '@angular/core';
import { RequestService } from '../request/request.service';

export type ScreenCode =
  | 'BUSCA_EMPRESAS'
  | 'EMPRESA_TAREFAS'
  | 'EMPRESA_BUSCAS_SALVAS'
  | 'EMPRESA_CARTEIRA';

@Injectable({ providedIn: 'root' })
export class ScreenAccessLogService {
  private readonly _requestService = inject(RequestService);

  registrar(screen: ScreenCode): void {
    const payload = {
      userType: localStorage.getItem('level'),
      userName: localStorage.getItem('userName'),
      userEmail: null,
      screen,
    };

    this._requestService
      .requestMethod(
        'company/api/Analytics/ScreenAccess',
        'POST',
        true,
        payload,
      )
      .subscribe({
        next: () => {},
        error: () => {},
      });
  }
}